import { de, type MessageKey } from './de.js'
import { ar, pl, tr, uk } from './translations.js'

const catalogues: Record<string, Partial<Record<MessageKey, string>>> = { de, tr, pl, uk, ar }
let active = 'de'

/** Languages offered in the app, each named in its own language. */
export const LANGUAGES: { code: string; name: string }[] = [
  { code: 'de', name: 'Deutsch' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'pl', name: 'Polski' },
  { code: 'uk', name: 'Українська' },
  { code: 'ar', name: 'العربية' },
]

const INTL: Record<string, string> = {
  de: 'de-DE',
  tr: 'tr-TR',
  pl: 'pl-PL',
  uk: 'uk-UA',
  // Latin digits keep dates and times readable next to addresses and IDs.
  ar: 'ar-u-nu-latn',
}

export function setLocale(locale: string): void {
  active = catalogues[locale] ? locale : 'de'
  if (typeof document !== 'undefined') {
    document.documentElement.lang = active
    document.documentElement.dir = active === 'ar' ? 'rtl' : 'ltr'
  }
}

export function getLocale(): string {
  return active
}

/** BCP 47 tag for `Intl` date and number formatting. */
export function intlLocale(): string {
  return INTL[active] ?? 'de-DE'
}

/** `t('sync.pending_many', { count: 3 })`, placeholders are `{name}`. */
export function t(key: MessageKey, params?: Record<string, string | number>): string {
  const template = catalogues[active]?.[key] ?? de[key] ?? key
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    params[name] === undefined ? match : String(params[name]),
  )
}

export type { MessageKey }
